import React from 'react';
import {
  Edit,
  List,
  Create,
  Datagrid,
  TextField,
  EditButton,
  DisabledInput,
  SimpleForm,
  TextInput,
  CardActions,
  ListButton,
} from 'react-admin';

const MediaTypeTitle = ({ record }) => {
  return <span>Media Type {record ? `"${record.name}"` : ''}</span>;
};

export const MediaTypesList = props => (
  <List title="Media Types" {...props} 
        bulkActionButtons={false}
        perPage={25}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <EditButton label="" />
    </Datagrid>
  </List>
);

const MediaTypesEditActions = ({ basePath, data, resource }) => (
  <CardActions>
      <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
  </CardActions>
);

export const MediaTypesEdit = props => (
  <Edit title={<MediaTypeTitle />} actions={<MediaTypesEditActions />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <TextInput source="name" />
    </SimpleForm>
  </Edit>
);

export const MediaTypesCreate = props => (
  <Create title="Create Media Type" actions={<MediaTypesEditActions />} {...props}>
    <SimpleForm>
      <TextInput source="id" />
      <TextInput source="name" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/mediatypes.js